<template>
  <b-modal
    id="modal-department-form"
    :title="isEdit ? 'Cập nhật phòng ban' : 'Thêm mới phòng ban'"
    size="md"
    centered
    hide-footer
    @hide="reset"
  >
    <b-overlay :show="loading">
      <form @submit.prevent="handleValidate">
        <b-row>
          <b-col>
            <basic-input
              :required="true"
              label="Tên phòng ban"
              name="name"
              placeholder="Nhập tên phòng ban"
              :value.sync="form.name"
              :state="validateState('name')"
              :invalidFeedback="errors.first('name')"
              v-validate="'required|max:100'"
              data-vv-as="Tên phòng ban"
              maxlength="100"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <basic-input
              label="Mô tả"
              name="description"
              placeholder="Nhập mô tả"
              :value.sync="form.description"
              :state="validateState('description')"
              :invalidFeedback="errors.first('description')"
              v-validate="'max:500'"
              data-vv-as="Mô tả"
              maxlength="500"
            />
          </b-col>
        </b-row>
        <div class="d-flex justify-content-end mt-2">
          <b-button class="btn mr-4" type="button" @click="cancel">
            Hủy
          </b-button>
          <b-button class="btn btn-success" type="submit">
            <span class="svg-icon">
              <inline-svg src="/media/svg/icons/Neolex/Basic/save.svg" />
            </span>
            Lưu
          </b-button>
        </div>
      </form>
    </b-overlay>
  </b-modal>
</template>
<script>
import DepartmentService from '../services/department.service';
export default {
  name: 'DepartmentForm',
  props: {
    department: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      form: {
        name: null,
        description: null,
      },
    };
  },
  computed: {
    isEdit() {
      return !!this.department;
    },
  },
  watch: {
    department(val) {
      if (val) {
        this.form.name = val.name;
        this.form.description = val.description;
      }
    },
  },
  methods: {
    handleValidate() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.onSubmit();
        }
      });
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.errors.has(ref);
      }
      return null;
    },
    async onSubmit() {
      try {
        this.loading = true;
        let meta, error, data;
        if (this.isEdit) {
          ({ meta, error, data } = await DepartmentService.update(this.$api, this.department.id, {
            name: this.form.name,
            description: this.form.description,
          }));
        } else {
          ({ meta, error, data } = await DepartmentService.create(this.$api, {
            name: this.form.name,
            description: this.form.description,
          }));
        }
        if (!meta.success) {
          return this.$toastr.e({
            title: 'Lỗi !',
            msg: error.message,
            preventDuplicates: true,
          });
        }
        this.$toastr.s({
          title: 'Thành công !',
          msg: this.isEdit
            ? 'Cập nhật phòng ban thành công'
            : 'Thêm phòng ban thành công',
        });
        this.$emit('save-success', data);
        this.cancel();
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi !',
          msg: error.message,
          preventDuplicates: true,
        });
      } finally {
        this.loading = false;
      }
    },
    cancel() {
      this.$bvModal.hide('modal-department-form');
    },
    reset() {
      this.form = { name: null, description: null };
      this.$validator.reset();
      this.$emit('reset');
    },
  },
};
</script>
